/**
 * A confirmação do e-mail (docs/spec/email.md): a conta nova só usa o RPG Desk depois de abrir o link
 * que chega no e-mail. Os prazos e os limites ficam aqui porque a tela de espera também os mostra.
 */

export const EMAIL_CONFIRMATION_LIMITS = {
  /** quanto tempo o link vale */
  linkMs: 48 * 60 * 60 * 1000,
  /** a espera entre um envio e o próximo (reenviar ou corrigir o e-mail) */
  resendMs: 60 * 1000,
  /** quantos envios uma conta faz por hora */
  sendsPerHour: 5,
  /** a conta que não confirma neste prazo, contado do cadastro, é apagada */
  deleteAfterMs: 7 * 24 * 60 * 60 * 1000,
  /** quantas contas um mesmo IP cria por hora, com a confirmação ligada */
  registrationsPerHour: 10,
} as const;

/** O parâmetro do endereço que leva o código do link: `https://rpgdesk.com/?confirm-email=<código>`. */
export const EMAIL_CONFIRMATION_PARAM = 'confirm-email';

/** As línguas dos e-mails, as mesmas da interface: o cadastro diz a da tela. */
export const EMAIL_LANGUAGES = ['pt-BR', 'en'] as const;
export type EmailLanguage = (typeof EMAIL_LANGUAGES)[number];

/**
 * O que o entrar, o cadastro e o /api/me dizem da conta que espera a confirmação (null: a conta já
 * confirmou, ou a confirmação está desligada no servidor).
 */
export type EmailConfirmationView = {
  /** o endereço para onde o link foi */
  email: string;
  /** o último envio que deu certo; null quando o último falhou (a tela pede para reenviar) */
  sentAt: number | null;
  /** quando o link do último envio vence */
  expiresAt: number;
  /** a partir de quando dá para pedir outro envio */
  resendAt: number;
  /** quando a conta é apagada, se não confirmar */
  deleteAt: number;
};
